const trimMeaningful = (s: string | null | undefined): string | undefined => {
  const t = s?.trim();
  return t && t !== 'N/A' ? t : undefined;
};

const tryParseInstant = (
  startTimeIso: string | null | undefined,
  startTimeFallback: string | null | undefined
): Date | null => {
  const iso = trimMeaningful(startTimeIso);
  if (iso) {
    const d = new Date(iso);
    if (!Number.isNaN(d.getTime())) return d;
  }
  const raw = trimMeaningful(startTimeFallback);
  if (raw) {
    const d = new Date(raw);
    if (!Number.isNaN(d.getTime())) return d;
  }
  return null;
};

export type EvalHistoryStartTimeParts = {
  display: string;
  /** Epoch ms for table sorting; null when the value could not be parsed */
  ms: number | null;
};

/**
 * Show eval run start time in the viewer's local timezone and locale.
 * Prefer `start_time_iso` when the API sends it so the instant is unambiguous.
 */
export function formatEvalHistoryStartTimeLocal(
  startTimeIso: string | null | undefined,
  startTimeFallback: string | null | undefined
): EvalHistoryStartTimeParts {
  const parsed = tryParseInstant(startTimeIso, startTimeFallback);
  if (!parsed) {
    const raw = trimMeaningful(startTimeIso) ?? trimMeaningful(startTimeFallback) ?? '';
    return { display: raw || 'N/A', ms: null };
  }
  return {
    display: parsed.toLocaleString(undefined, {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZoneName: 'short',
    }),
    ms: parsed.getTime(),
  };
}
